<ng-container *ngIf="render$ | async" />

<div id="fasteners-form" class="flex flex-auto flex-row justify-start items-stretch gap-4 h-full">
  <div class="basis-[42%] custom-hole-list-wrapper h-full" cslPerfectScrollbar>
    <csl-custom-fasteners
      [editable]="editable"
      (selectedHoleChange)="onSelectedCustomHole($event)"
      (selectedFastenersSetChange)="onSelectedFastenersSet($event)"
      [selectedHole]="selectedCustomFastener"
      [selectedFastenersSet]="selectedFastenersSet"
      [mainMaterialThickness]="mainMaterialThickness"
      [panel]="panel"
      (formChanged)="customFastenersChange($event)"></csl-custom-fasteners>
  </div>

  <div class="flex flex-col overflow-auto flex-1 flex-col justify-start items-start" cslPerfectScrollbar>
    <div class="flex-1 w-full flex items-center justify-center">
      <csl-svg-workspace
      #svgWorkspace
      class="panel-schema"
      [p]="panel"
      [selectableHoles]="true"
      [highlightedHole]="selectedCustomFastener"
      (highlightedHoleChange)="onSelectedCustomHole($event)"
      (highlightedFastenersSetChange)="onSelectedFastenersSet($event)"
      [highlightedFastenersSet]="selectedFastenersSet">
      </csl-svg-workspace>
    </div>

    <div class="flex flex-wrap items-center justify-center gap-4 mt-auto pt-4 pb-2">
    
      <div class="flex items-center gap-1">
        <svg width="24" height="24" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
          <path
            class="c-hole-face through custom-hole"
            d="M13.183333333333334 12.5 a3.8166666666666664 3.8166666666666664 0 1 0 7.633333333333333 0 a3.8166666666666664 3.8166666666666664 0 1 0 -7.633333333333333 0"
            stroke="black"
            fill="white"
            stroke-width="1px"></path>
        </svg>
        <span class="text-sm text-gray-600">— сквозное отверстие</span>
      </div>

      <div class="flex items-center gap-1">
        <svg width="24" height="24" viewBox="0 0 30 25" xmlns="http://www.w3.org/2000/svg">
          <path
            class="c-hole-back custom-hole"
            d="M17.133333333333336 12.5 a6 6 0 1 0 12 0 a6 6 0 1 0 -12 0"
            stroke="none"
            fill="#863600"></path>
        </svg>
        <span class="text-sm text-gray-600">— глухое отверстие лицевая сторона</span>
      </div>

      <div class="flex items-center gap-1">
        <svg width="24" height="24" viewBox="0 0 30 25" xmlns="http://www.w3.org/2000/svg">
          <path
            class="c-hole-back custom-hole"
            d="M17.133333333333336 12.5 a6 6 0 1 0 12 0 a6 6 0 1 0 -12 0"
            stroke="none"
            fill="#a0a0a0"></path>
        </svg>
        <span class="text-sm text-gray-600">— глухое отверстие обратная сторона</span>
      </div>
    </div>
  </div>
</div>
